export default __webpack_public_path__ + "static/media/login_print.33801153.png";